import { addHours, format, toDate } from "date-fns"
import { ptBR } from "date-fns/locale"
const formatDocument = (value?: string) => {
  if (!value) {
    return ""
  }
  // Remove caracteres especiais, mantendo letras e números (max 14 para CNPJ)
  const cleanValue = value
    .replaceAll(/[^A-Za-z0-9]/g, "")
    .toUpperCase()
    .slice(0, 14)

  // CPF: apenas números, 11 dígitos
  if (/^\d{11}$/.test(cleanValue)) {
    return cleanValue.replace(
      /(\d{3})(\d{3})(\d{3})(\d{2})/,
      "$1.$2.$3-$4"
    )
  }

  // CNPJ: 14 caracteres (alfanumérico nas posições 1-12, numérico nas posições 13-14)
  if (cleanValue.length === 14) {
    return cleanValue.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    )
  }

  return value
}
const formatPhoneNumber = (value?: string) => {
  return value?.replaceAll(
    /(\d{2})(\d{4,5})(\d{4})/g,
    "($1) $2-$3"
  )
}
const formatMoney = (value?: number | null) => {
  if (typeof value !== "number" || Number.isNaN(value))
    return "R$ 0,00"
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
interface FormatDateProps {
  date: string | Date
  formatLayout?: string
}
const formatDate = ({
  date,
  formatLayout = "dd/MM/yyyy",
}: FormatDateProps) => {
  if (date instanceof Date) {
    return format(date, formatLayout, { locale: ptBR })
  }
  if (date.split("T").length > 1) {
    return format(toDate(date), formatLayout, {
      locale: ptBR,
    })
  }
  return format(toDate(addHours(date, 3)), formatLayout, {
    locale: ptBR,
  })
}
export {
  formatDate,
  formatDocument,
  formatMoney,
  formatPhoneNumber,
}
